export default __webpack_public_path__ + "3c46358b9284c962015827ad0f7fa655.png";